import { render, staticRenderFns } from "./RemoveAccessToContractorNew.vue?vue&type=template&id=fa9ff762"
import script from "./RemoveAccessToContractorNew.vue?vue&type=script&lang=ts"
export * from "./RemoveAccessToContractorNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa9ff762')) {
      api.createRecord('fa9ff762', component.options)
    } else {
      api.reload('fa9ff762', component.options)
    }
    module.hot.accept("./RemoveAccessToContractorNew.vue?vue&type=template&id=fa9ff762", function () {
      api.rerender('fa9ff762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/managers/RemoveAccessToContractorNew.vue"
export default component.exports